import styled from 'styled-components';

const Content = styled.main`
  flex-grow: 1;
  overflow-y: scroll;
  position: relative;
`;

export default Content;
